import { useEffect, useState } from 'react';
import { API_PATH } from '../App';
import LoadingSpinner from '../components/ui-components/Loading-Spinner';
import GeneratedCard from '../components/ui-components/GeneratedCard';

const Home = () => {
  const [generatedPlace, setGeneratedPlace] = useState(null);
  const [state, setState] = useState({
    isLoaded: false,
    error: null,
    places: [],
  });

  useEffect(() => {
    fetch(`${API_PATH}v1/places`)
      .then((response) => {
        if (response.status !== 200) {
          let err = Error;
          err.message = 'Invalid response code: ' + response.status;
          setState({ error: err });
          return null;
        }
        return response.json();
      })
      .then((json) => {
        setState((prevState) => ({
          ...prevState,
          places: json.places,
          isLoaded: true,
        }));
      });
  }, []);

  const { isLoaded, error, places } = state;

  const handleOnGenerate = (evt) => {
    evt.preventDefault();

    const randIdx = Math.floor(Math.random() * places.length);
    setGeneratedPlace({ ...places[randIdx] });
  };

  const handleOnClear = () => {
    setGeneratedPlace(null);
  };

  if (error) return <div>Error: error.message</div>;
  if (!isLoaded) return <LoadingSpinner />;
  return (
    <div className="mx-auto max-w-3xl px-4 py-5 sm:p-6">
      {generatedPlace && <GeneratedCard place={generatedPlace} />}
      <div className="mt-10 flex items-center justify-center gap-x-6">
        <button
          type="button"
          className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:col-start-2"
          onClick={handleOnGenerate}
        >
          Generate
        </button>
        <button
          type="button"
          className="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
          onClick={handleOnClear}
        >
          Clear
        </button>
      </div>
    </div>
  );
};

export default Home;
